import { useStore } from 'vuex'

export default {
    name: "StafetEditPageHero",
    setup(){
        const store = useStore()

        const openMailudsendelseOverlay = function(e) {
            store.commit('main/set_page_overlay_content_data', { type: "Stafet", mailudsendelse: null })
            store.dispatch('main/openPageOverlay', {
                overlayContent: "StafetMailEditorOverlay",
                returnTarget: e.currentTarget
            })
        }

        return {
            openMailudsendelseOverlay
        }
    }
}